import { useQuery } from "@tanstack/react-query";
import { useCallback, useMemo, useState } from "react";
import { apiFetch } from "../APIClient";

function shuffle<T>(array: T[]): T[] {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

const fetchTalkingPoints = async (): Promise<string[]> => {
  const response = await apiFetch("api/event/talking-points");
  if (!response.ok) {
    throw new Error("토킹 포인트를 가져오는데 실패했습니다");
  }
  return response.json();
};

export const useGetRandomTalkingPoints = () => {
  const { data: talkingPoints, isPending, isError } = useQuery({
    queryKey: ["talkingPoints"],
    queryFn: fetchTalkingPoints,
  });

  const shuffledPoints = useMemo(() => {
    if (!talkingPoints) return [];
    return shuffle(talkingPoints);
  }, [talkingPoints]);

  const [currentIndex, setCurrentIndex] = useState(0);

  const currentPoint = shuffledPoints[currentIndex] ?? null;
  const isExhausted = shuffledPoints.length > 0 && currentIndex >= shuffledPoints.length;

  const next = useCallback(() => {
    setCurrentIndex((prev) => prev + 1);
  }, []);

  return {
    currentPoint,
    isExhausted,
    next,
    isPending,
    isError,
  };
};
